<template>
  <v-container fluid fill-height>
    <v-layout NAalign-center justify-center>
        <v-flex xs12 sm8 md4>
        <v-card class="mt-4">
            <v-toolbar classa="hidden-sm-and-down" dark color="secondary">
							<v-toolbar-title>
                <v-icon>how_to_reg</v-icon>
                Sign Up
              </v-toolbar-title>
							<v-spacer></v-spacer>           
            </v-toolbar>
            <v-card-text>
            <v-form ref="form">
							<v-text-field
								:rules="[rules.required]"
								prepend-icon="person"
								v-model="username"
                autofocus
								name="username"
								label="Username"
								type="text"></v-text-field>
							<v-text-field
								:rules="[rules.required]"
								prepend-icon="face"
								v-model="fullname"
								name="fullname"
								label="Full Name"
								type="text"></v-text-field>                
							<v-text-field
								:rules="[rules.required, rules.email]"
								prepend-icon="email"
								v-model="email"
								name="email"
								label="Email"
								type="text"></v-text-field>                
							<v-text-field
                @keydown.enter="registerHandler"
								:rules="[rules.required, rules.min]"
								prepend-icon="lock"
								v-model="password"
								name="password"
								label="Password"
								id="password"
								type="password"></v-text-field>
            </v-form>
            <v-alert
              :value="hasError"
              type="error">
              {{ errorText }}
            </v-alert>            
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="registerHandler">Sign Up</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-spacer></v-spacer>
              Already registered? <a href="/sign-in" class="ml-2">Sign in!</a>
            </v-card-actions>            
        </v-card>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
		data () {
			return {
				username: '',
				password: '',
        email: '',
        fullname: '',
        rules: {
          required: value => !!value || '', //'Required.',
          min: v => v.length >= 6 || '', //'Min 8 characters',
          email: v => /.+@.+/.test(v) || 'E-mail must be valid',
          emailOLD: [
            (v) => !!v || 'E-mail is required',
            v => /.+@.+/.test(v) || "E-mail must be valid"
          ],
          emailMatch: () => ('The email and password you entered don\'t match')
        },
        hasError: false,
        errorText: ''          
			}
    },
    methods: {
      submit () {
        this.$refs.form.validate()
      },
      clear () {
        this.$refs.form.reset()
      },
      registerHandler () {
        if (!this.$refs.form.validate()) {
          return
        }
        this.hasError = false
        this.$httpApi
          .post('/users', {
            username: this.username,
            fullname: this.fullname,
            email: this.email,
            password: this.password
          })
          .then((result) => {
            localStorage.jwt = result.data.accessToken
            this.$httpApi.defaults.headers.common['Authorization'] = result.data.accessToken;
            console.log(result)
            this.$router.push({ name: 'sign-in' })             
          })
          .catch(err => {
            // console.error("error*", typeof err, err.response, err.response.data.errors.map(x => x.message), err.message, err)
            this.hasError = true
            this.errorText = 'Signup failed! ' + err.response.data.errors.map(x => x.message)            
          })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>